<template>
  <div class="h-all" @mousewheel="row()">
    <div class="hall" ref="hall" @mouseenter="whited()" @mouseleave="trans()">
      <div class="h-left">
        <div class="h-title" @click="jumpd()">
          <div class="h-pic"><img class="h-img" src="../../assets/img/度云科技logo.png" alt=""></div>
          <div class="h-t-title">度云科技</div>
        </div>
        <div class="h-body">
          <ul class="layui-nav" style="color: black;">
            <li class="layui-nav-item" style="color: black; height: 50px;line-height:50px;font-size:13px"><a class="jp"
                @click="jumpd()" style="color: black;">首页</a></li>
            <li class="layui-nav-item" style="color: black; height: 50px;line-height:50px;font-size:13px">
              <a class="jp" style="color: black; height: 50px;">云服务代理</a>
              <dl class="layui-nav-child" style="color: black;background-color:white; border-radius: 8px;">
                <dd v-for="(item, i) in found" :key="i"
                  style="color: black;background-color:white; border-radius: 8px;">
                  <a href="javascript:;" style="color: black;background-color:white; border-radius: 8px;">
                    <div class="h-p-title">{{ item.name }}</div>
                  </a>
                  <a class="jp" style="color: black;background-color:white; border-radius: 8px;">
                    <div class="h-p-body" v-for="(product, index) in item.product" :key="index"
                      @click="go(product, index)">{{ product.name }}
                    </div>
                  </a>
                </dd>
              </dl>
            </li>
            <li class="layui-nav-item" @click="prody()"><a class="jp"
                style="color: black;  height: 50px;line-height:50px;font-size:13px">GEO服务</a></li>
            <li class="layui-nav-item" @click="payy()"><a class="jp"
                style="color: black;  height: 50px;line-height:50px;font-size:13px">关于我们</a></li>
            
          </ul>
        </div>
      </div>
      <div class="h-right">
        <div class="h-foot" @click="jump()">免费体验</div>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  data() {
    return {
      navigator: [{
        name: '首页',
        url: 'index',
        product: []
      },
      {
        name: '产品矩阵',
        url: 'product',
        product: [ {
          name: '百度智能云计算',
          product: [
            { name: '智能通信', url: 'free' },
          ]
        }, {
          name: '百度智能云大模型',
          product: [
            { name: '智能语音', url: 'free' },
          ]
        },{
          name: '百度智能云客悦·one',
          product: [
            { name: '智能客服', url: 'one' },
            { name: '智能外呼', url: 'two' },
            { name: '客户洞察', url: 'tree' }]
        }]
      },
      {
        name: '客户案例',
        url: 'solution',
        product: []
      },
      {
        name: '定价',
        url: 'pay',
        product: []
      }
      ],
      found: [{
          name: '百度智能云服务器',
          product: [
            { name: '云计算', url: 'free' },
          ]
        }, {
          name: '百度智能云大模型',
          product: [
            { name: '百度千帆大模型', url: 'free' },
          ]
        },{
          name: '百度智能云客悦·one',
          product: [
            { name: '智能客服', url: 'one' },
            { name: '智能外呼', url: 'two' },
            { name: '客户洞察', url: 'tree' }]
        }],
      show: false,
      timeup: null,
      net: '',
      white: true,
      rigth: true,
    }
  },
  methods: {
    foundt(index) {
      this.found = this.navigator[index].product
      if (this.found.length != 0) {
        this.show = true
      }
    },
    whited() {
      if (this.rigth == true) {
        this.$refs.hall.style.backgroundColor = "white"
        this.$refs.hall.style.boxShadow = ''
        this.$refs.hall.style.width = "100%"
        this.$refs.hall.style.marginTop = '0'
        this.$refs.hall.style.borderRadius = '0'
        this.white = false
      }
    },
    trans() {
      this.white = true
    },
    jumpd() {
      if (window.location.href != this.$route.query.id) {

        this.$router.push({ name: 'index', query: { id: window.location.href } })

      }
    },
    go(product) {
      if (window.location.href != this.$route.query.id) {
        console.log(product);
        this.$router.push({ name: product.url, query: { id: window.location.href } })

      }
    },
    jump() {
      if (window.location.href != this.$route.query.id) {
        this.$router.push({ name: 'free', query: { id: window.location.href } })


      }
      // window.location.href = 'https://console.bce.baidu.com/agent/#/agent/account/bind~token=c3d6b7ce042c21ac1a976ada619353d67f48e16b7714c637a773d37137e4c6d0&inviteType=agentUser&agentRank=0&iamUserName=kun-sales'
    },
    clear() {
      this.found = []
      this.show = false
    },
    row() {


    },
    prody() {
      if (window.location.href != this.$route.query.id) {
        this.$router.push({ name: 'free', query: { id: window.location.href } })

      }
    },
    payy() {
      if (window.location.href != this.$route.query.id) {
        this.$router.push({ name: 'pay', query: { id: window.location.href } })

      }
    }
  },
  mounted() {
    this.timeup = setInterval(() => {
      if (window.scrollY != 0) {
        this.$refs.hall.style.backgroundColor = "white"
        this.$refs.hall.style.boxShadow = '0px 0px 30px #eaeaea'
        this.$refs.hall.style.width = "90%"
        this.$refs.hall.style.marginTop = '10px'
        this.$refs.hall.style.borderRadius = '999px'
        this.rigth = false
      } else if (window.scrollY == 0 && this.white == true) {
        this.rigth = true
        this.$refs.hall.style.backgroundColor = "transparent"
        this.$refs.hall.style.boxShadow = ''
        this.$refs.hall.style.width = "100%"
        this.$refs.hall.style.marginTop = '0'
        this.$refs.hall.style.borderRadius = '0'
      }
    }, 1);
  },
  beforeDestroy() {
    this.timeup = null
  }
}
</script>

<style lang="scss">
.h-all {


  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
  display: inline-block;

  .layui-nav .layui-this:after,
  .layui-nav-bar {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 0;
    height: 3px;
    /* background-color: #16b777; */
    -webkit-transition: all .1s;
    transition: all .1s;
    pointer-events: none;
  }

  .layui-nav-bar {
    background-color: #2468f2;
  }

  .layui-nav {
    background-color: transparent;
    height: 50px;

    .layui-nav-item {
      height: 50px;

      li {
        height: 50px;

        a {
          height: 50px;
        }
      }
    }
  }

  .hall {
    width: 100%;
    min-width: 1200px;
    height: 50px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    transition: all .2s;
  }

  .hall:hover {
    background-color: white;
    box-shadow: 0px 0px 30px #eaeaea;
    ;
    transition: all .1s;
  }

  .h-title {
    cursor: pointer;
    height: 30px;
    display: flex;
    margin-top: 10px;
    margin-left: 30px;
  }

  .h-pic {
    height: 30px;
    width: 30px;
  }

  .h-img {
    width: 30px;
    height: 30px;
  }

  .h-t-title {
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    font-weight: 600;
    margin-left: 5px;
  }

  .h-foot {
    height: 34px;
    line-height: 34px;
    padding: 0 15px;
    font-size: 12px;
    background-color: #2468f2;
    border-radius: 5px;
    margin-top: 8px;
    color: white;
    cursor: pointer;
    margin-right: 20px;
  }

  .h-p-body:hover {
    color: #1a57d1;
  }

  .h-foot:hover {
    background-color: #1450c8;
  }

  .h-right {
    display: flex;
  }

  .login {
    height: 30px;
    line-height: 30px;
    margin-top: 10px;
    font-size: 13px;
    margin-right: 24px;
    cursor: pointer;
    ;
  }

  .h-body {
    display: flex;
  }

  .h-navigation {
    height: 48px;
    line-height: 49px;
    margin-left: 20px;
    cursor: pointer;
    font-size: 13px;
  }

  .h-navigation:hover {
    border-bottom: 2px solid #2468f2;
  }

  .h-left {
    display: flex;
  }

  .login:hover {
    color: #2468f2;
  }

  .h-product {
    width: fit-content;
    margin-left: 210px;
    background-color: white;
    margin-top: 10px;
    border-radius: 10px;
    box-shadow: 0px 0px 4px #dadada;
    ;
    font-size: 13px;
    padding: 10px 24px;
  }

  .h-p-a {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .h-p-title {
    border-bottom: 1px solid rgb(236, 236, 236);
    font-weight: 600;
    margin-bottom: 10px;
    height: 30px;
    line-height: 30px;
  }

  .h-p-body {
    margin-top: 10px;
  }

  .jp {
    cursor: pointer;
  }
}
</style>
